<div class="w-100 h-100 map-svg-container">
    <svg
      #svgElement
      style="width: 100%; height: 100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2360 1280"
    >
        <defs>
            <style>
              .dls-1,
              .dls-7 {
                fill: #c6c6c6;
              }

              .dls-2 {
                fill: #e5e5e5;
              }

              .dls-3 {
                fill: #c2c2c2;
                opacity: 0.5;
              }

              .dls-3,
              .dls-7 {
                isolation: isolate;
              }

              .dls-4 {
                fill: #00a3ae;
              }

              .dls-5 {
                fill: #fff;
              }

              .dls-6 {
                fill: #b3b3b3;
              }

              .dls-7 {
                opacity: 0.4;
              }
            </style>
        </defs>
        <g #svgGElement id="Floor-1">
            <polygon
                id="floor"
                class="dls-2"
                points="2313.57 1135.56 2279.77 95.86 2285.57 90.06 2251.07 55.55 2244.27 62.35 91.27 62.35 83.17 54.26 46.17 91.25 59.37 104.45 96.07 1225.76 2313.57 1135.56"
            />
            <path
                id="islands"
                class="dls-3"
                d="M2094.87,894.05v65.5a47.86,47.86,0,0,1-46.5,47.8l-766.1,20.8a47.87,47.87,0,0,1-49.1-46.5V858.85a12.53,12.53,0,0,1,12.46-12.6h801.44A47.81,47.81,0,0,1,2094.87,894.05ZM335.47,741.25l770.6-4.9-1.7-173.7H336a8.55,8.55,0,0,1-1.6,0,33.4,33.4,0,0,0-31.91,34.81,1.15,1.15,0,0,0,0,.19l5.5,117.6A27.3,27.3,0,0,0,335.47,741.25Zm756.2,105H347.87a35.32,35.32,0,0,0-35.4,35.24V984.15a54.7,54.7,0,0,0,54.7,54.7h684.7a54.71,54.71,0,0,0,54.7-54.7v-123A15,15,0,0,0,1091.67,846.25Zm954.2-111.7a36,36,0,0,0,34.7-37.24v-.16l-4-104.5a36,36,0,0,0-36-34.7h-799.1v176.6ZM1795,453.85h250.3V315.35l150.6-5.8v-32H1795a26.69,26.69,0,0,0-26.7,26.68V427.15A26.75,26.75,0,0,0,1795,453.85Zm-104.6-171.4H644.07v171.4h1046.3ZM317.27,322v136.2h228.4a23.86,23.86,0,0,0,23.8-23.8V302.25a23.87,23.87,0,0,0-23.8-23.8H407.57l-228.7,13.1-3.3,38.6Z"
            />
            <path
                id="kibejarat"
                class="dls-1"
                d="M1591.67,1101.65q9-41.25,18.1-82.5l212.6-5.7a41.46,41.46,0,0,1-41.4,41.3h2.7a41.2,41.2,0,0,1,41,40.4Zm-1002-6.9h-2.5a40.84,40.84,0,0,0-40.8,40.8l462.2-16.1-3-80.6L546.37,1049v2.5a43.32,43.32,0,0,0,43.3,43.3Z"
            />
            <path
                id="entrance_bg"
                data-name="entrance bg"
                class="dls-4"
                d="M1314.37,1109.65l-1.8-82.4,278.3-7.5q-9.15,41.25-18.2,82.5Zm-188.9-187v73.4a118.85,118.85,0,0,0,122.1,115.5h0l20-.6-2.3-83.5-20,.6h-1a35.28,35.28,0,0,1-35.3-35.28V922.65h14.1l-55.8-55.7-55.8,55.7Zm175.5,187.4-2.3-83.5-26.7.8,2.3,83.5Z"
            />
            <path
                id="entrance"
                class="dls-5"
                d="M1359.07,1071.15l.2,7-20.3.5-.8-26.5,20.3-.5.2,7-12.2.3.1,2.6,11.9-.3.2,7-11.9.3.1,2.9Zm20.5-20.1.3,12.6-9.6-12.4-8.3.2.7,26.7,8.1-.2-.3-13.5,10.1,13.3,7.8-.2-.7-26.7Zm33.4-.8-22.4.6.2,7,7.2-.2.5,19.7,8.1-.2-.5-19.7,7.1-.2Zm22.4,16.6,5.1,9.3-9.2.2-3.9-8.2-2.9.1.2,8.4-8.1.2-.7-26.7,14.3-.4c6.3-.2,9.7,3.9,9.8,8.9a8.71,8.71,0,0,1-4.6,8.2Zm-3.6-8c0-1.5-1.3-2.1-2.7-2l-4.9.1.1,4.2,4.9-.1c1.4,0,2.6-.7,2.6-2.2Zm28.5-10,10.5,26.5-9.2.2-1-3-9.6.3-.9,3.1-9.2.2,9.2-27Zm-2.1,16.7-2.9-8.5-2.4,8.6Zm30.9-17.4.3,12.7-9.6-12.4-8.3.2.7,26.7,8.1-.2-.3-13.5,10.1,13.2,7.8-.2-.7-26.7Zm26.1,19.4a6.71,6.71,0,0,1-.3-13.4,5.88,5.88,0,0,1,5.3,3.8l6.9-3.4a12.37,12.37,0,0,0-12.3-7.5c-8.3.2-14.5,5.9-14.3,14.2s6.7,13.7,14.9,13.4a12.55,12.55,0,0,0,11.9-8.1l-7-3a5.56,5.56,0,0,1-5.1,4Zm35.2-1.4-12.2.3-.1-2.9,11.9-.3-.2-7-11.9.3-.1-2.6,12.2-.3-.2-7-20.3.5.8,26.5,20.3-.5Z"
            />
            <g #svgRectGElement id="PLACES">
                <rect
                    id="_1"
                    data-name="1"
                    class="dls-6"
                    x="1046.07"
                    y="848.55"
                    width="50.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam"
                    class="dls-5"
                    x="1047.74"
                    y="911.14"
                    width="47.36"
                    height="22.76"
                />
                <rect
                    id="_2"
                    data-name="2"
                    class="dls-6"
                    x="998.87"
                    y="848.55"
                    width="47.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-2"
                    class="dls-5"
                    x="998.84"
                    y="911.14"
                    width="47.36"
                    height="22.76"
                />
                <rect
                    id="_3"
                    data-name="3"
                    class="dls-6"
                    x="950.97"
                    y="848.55"
                    width="47.9"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-3"
                    class="dls-5"
                    x="952.67"
                    y="911.14"
                    width="44.53"
                    height="22.76"
                />
                <rect
                    id="_4"
                    data-name="4"
                    class="dls-6"
                    x="900.87"
                    y="848.55"
                    width="50.1"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-4"
                    class="dls-5"
                    x="902.54"
                    y="911.14"
                    width="46.76"
                    height="22.76"
                />
                <rect
                    id="_5"
                    data-name="5"
                    class="dls-6"
                    x="851.87"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-5"
                    class="dls-5"
                    x="853.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_6"
                    data-name="6"
                    class="dls-6"
                    x="802.87"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-6"
                    class="dls-5"
                    x="804.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_7"
                    data-name="7"
                    class="dls-6"
                    x="753.97"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-7"
                    class="dls-5"
                    x="755.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_8"
                    data-name="8"
                    class="dls-6"
                    x="704.97"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-8"
                    class="dls-5"
                    x="706.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_9"
                    data-name="9"
                    class="dls-6"
                    x="655.97"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-9"
                    class="dls-5"
                    x="657.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_10"
                    data-name="10"
                    class="dls-6"
                    x="606.97"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-10"
                    class="dls-5"
                    x="608.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_11"
                    data-name="11"
                    class="dls-6"
                    x="557.97"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-11"
                    class="dls-5"
                    x="559.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_12"
                    data-name="12"
                    class="dls-6"
                    x="508.97"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-12"
                    class="dls-5"
                    x="510.54"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_13"
                    data-name="13"
                    class="dls-6"
                    x="441.37"
                    y="848.55"
                    width="67.6"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-13"
                    class="dls-5"
                    x="443.04"
                    y="911.14"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_14"
                    data-name="14"
                    class="dls-6"
                    x="392.37"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-14"
                    class="dls-5"
                    x="394.04"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_15"
                    data-name="15"
                    class="dls-6"
                    x="343.37"
                    y="848.55"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-15"
                    class="dls-5"
                    x="345.04"
                    y="911.14"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_16"
                    data-name="16"
                    class="dls-6"
                    x="1046.07"
                    y="648.85"
                    width="50.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-16"
                    class="dls-5"
                    x="1047.74"
                    y="710.02"
                    width="47.36"
                    height="22.76"
                />
                <rect
                    id="_17"
                    data-name="17"
                    class="dls-6"
                    x="998.87"
                    y="648.85"
                    width="47.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-17"
                    class="dls-5"
                    x="1000.54"
                    y="710.02"
                    width="43.96"
                    height="22.76"
                />
                <rect
                    id="_18"
                    data-name="18"
                    class="dls-6"
                    x="950.97"
                    y="648.85"
                    width="47.9"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-18"
                    class="dls-5"
                    x="952.94"
                    y="710.02"
                    width="43.96"
                    height="22.76"
                />
                <rect
                    id="_19"
                    data-name="19"
                    class="dls-6"
                    x="900.87"
                    y="648.85"
                    width="50.1"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-19"
                    class="dls-5"
                    x="902.54"
                    y="710.02"
                    width="46.76"
                    height="22.76"
                />
                <rect
                    id="_20"
                    data-name="20"
                    class="dls-6"
                    x="851.87"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-20"
                    class="dls-5"
                    x="853.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_21"
                    data-name="21"
                    class="dls-6"
                    x="802.87"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-21"
                    class="dls-5"
                    x="804.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_22"
                    data-name="22"
                    class="dls-6"
                    x="753.97"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-22"
                    class="dls-5"
                    x="755.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_23"
                    data-name="23"
                    class="dls-6"
                    x="704.97"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-23"
                    class="dls-5"
                    x="706.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_24"
                    data-name="24"
                    class="dls-6"
                    x="655.97"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-24"
                    class="dls-5"
                    x="657.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_25"
                    data-name="25"
                    class="dls-6"
                    x="606.97"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-25"
                    class="dls-5"
                    x="608.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_26"
                    data-name="26"
                    class="dls-6"
                    x="557.97"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-26"
                    class="dls-5"
                    x="559.54"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_27"
                    data-name="27"
                    class="dls-6"
                    x="496.27"
                    y="648.85"
                    width="61.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-27"
                    class="dls-5"
                    x="498.04"
                    y="710.02"
                    width="58.16"
                    height="22.76"
                />
                <rect
                    id="_28"
                    data-name="28"
                    class="dls-6"
                    x="432.07"
                    y="648.85"
                    width="64.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-28"
                    class="dls-5"
                    x="433.74"
                    y="710.02"
                    width="60.78"
                    height="22.76"
                />
                <rect
                    id="_29"
                    data-name="29"
                    class="dls-6"
                    x="383.07"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-29"
                    class="dls-5"
                    x="384.74"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_30"
                    data-name="30"
                    class="dls-6"
                    x="334.07"
                    y="648.85"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-30"
                    class="dls-5"
                    x="335.74"
                    y="710.02"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_31"
                    data-name="31"
                    class="dls-6"
                    x="343.37"
                    y="934.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-31"
                    class="dls-5"
                    x="345.04"
                    y="995.29"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_32"
                    data-name="32"
                    class="dls-6"
                    x="392.37"
                    y="934.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-32"
                    class="dls-5"
                    x="394.04"
                    y="995.29"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_33"
                    data-name="33"
                    class="dls-6"
                    x="441.37"
                    y="934.25"
                    width="67.6"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-33"
                    class="dls-5"
                    x="443.04"
                    y="995.29"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_34"
                    data-name="34"
                    class="dls-6"
                    x="112.23"
                    y="1108.15"
                    width="96.89"
                    height="51.16"
                    transform="translate(-41.83 6.72) rotate(-2.12)"
                />
                <rect
                    style="display: none"
                    id="rendszam-34"
                    class="dls-5"
                    x="114.59"
                    y="1137.08"
                    width="64.16"
                    height="22.76"
                    transform="translate(-42.38 6.21) rotate(-2.12)"
                />
                <rect
                    id="_35"
                    data-name="35"
                    class="dls-6"
                    x="110.48"
                    y="1062.56"
                    width="97.1"
                    height="45.6"
                    transform="translate(-40.42 6.7) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-35"
                    class="dls-5"
                    x="111.4"
                    y="1085.59"
                    width="64.16"
                    height="22.76"
                    transform="matrix(1, -0.04, 0.04, 1, -40.48, 6.06)"
                />
                <rect
                    id="_36"
                    data-name="36"
                    class="dls-6"
                    x="108.67"
                    y="1013.56"
                    width="97.1"
                    height="49"
                    transform="translate(-38.65 6.59) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-36"
                    class="dls-5"
                    x="109.72"
                    y="1039.24"
                    width="64.16"
                    height="22.76"
                    transform="translate(-38.77 5.96) rotate(-2.12)"
                />
                <rect
                    id="_37"
                    data-name="37"
                    class="dls-6"
                    x="106.88"
                    y="965.68"
                    width="97.28"
                    height="49.04"
                    transform="translate(-39.45 7.01) rotate(-2.29)"
                />
                <rect
                    style="display: none"
                    id="rendszam-37"
                    class="dls-5"
                    x="107.91"
                    y="990.43"
                    width="64.16"
                    height="22.76"
                    transform="translate(-36.96 5.86) rotate(-2.12)"
                />
                <rect
                    id="_38"
                    data-name="38"
                    class="dls-6"
                    x="105.08"
                    y="915.65"
                    width="97.1"
                    height="49"
                    transform="translate(-35 6.39) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-38"
                    class="dls-5"
                    x="106.09"
                    y="941.34"
                    width="64.16"
                    height="22.76"
                    transform="matrix(1, -0.04, 0.04, 1, -35.15, 5.76)"
                />
                <rect
                    id="_39"
                    data-name="39"
                    class="dls-6"
                    x="102.96"
                    y="866.86"
                    width="97.2"
                    height="49"
                    transform="translate(-35.5 6.77) rotate(-2.29)"
                />
                <rect
                    style="display: none"
                    id="rendszam-39"
                    class="dls-5"
                    x="104.47"
                    y="892.58"
                    width="64.16"
                    height="22.76"
                    transform="matrix(1, -0.04, 0.04, 1, -33.35, 5.67)"
                />
                <rect
                    id="_40"
                    data-name="40"
                    class="dls-6"
                    x="101.48"
                    y="821.15"
                    width="97.1"
                    height="45.6"
                    transform="translate(-31.41 6.19) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-40"
                    class="dls-5"
                    x="102.47"
                    y="843.19"
                    width="64.16"
                    height="22.76"
                    transform="translate(-31.52 5.56) rotate(-2.12)"
                />
                <rect
                    id="_41"
                    data-name="41"
                    class="dls-6"
                    x="99.68"
                    y="772.15"
                    width="97.1"
                    height="49"
                    transform="translate(-29.64 6.09) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-41"
                    class="dls-5"
                    x="100.76"
                    y="797.83"
                    width="64.16"
                    height="22.76"
                    transform="translate(-29.84 5.47) rotate(-2.12)"
                />
                <rect
                    id="_42"
                    data-name="42"
                    class="dls-6"
                    x="97.88"
                    y="723.15"
                    width="97.1"
                    height="49"
                    transform="matrix(1, -0.04, 0.04, 1, -27.82, 5.99)"
                />
                <rect
                    style="display: none"
                    id="rendszam-42"
                    class="dls-5"
                    x="98.94"
                    y="748.83"
                    width="64.16"
                    height="22.76"
                    transform="translate(-28.03 5.37) rotate(-2.12)"
                />
                <rect
                    id="_43"
                    data-name="43"
                    class="dls-6"
                    x="95.97"
                    y="674.26"
                    width="97.1"
                    height="49"
                    transform="translate(-25.99 5.88) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-43"
                    class="dls-5"
                    x="98.04"
                    y="699.93"
                    width="64.16"
                    height="22.76"
                    transform="translate(-26.22 5.3) rotate(-2.12)"
                />
                <rect
                    id="_44"
                    data-name="44"
                    class="dls-6"
                    x="94.17"
                    y="625.25"
                    width="97.1"
                    height="49"
                    transform="translate(-24.16 5.78) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-44"
                    class="dls-5"
                    x="95.31"
                    y="650.94"
                    width="64.16"
                    height="22.76"
                    transform="translate(-24.41 5.17) rotate(-2.12)"
                />
                <rect
                    id="_45"
                    data-name="45"
                    class="dls-6"
                    x="92.28"
                    y="573.06"
                    width="97.1"
                    height="52.3"
                    transform="translate(-22.28 5.68) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-45"
                    class="dls-5"
                    x="93.62"
                    y="601.53"
                    width="64.16"
                    height="22.76"
                    transform="translate(-22.59 5.07) rotate(-2.12)"
                />
                <rect
                    id="_46"
                    data-name="46"
                    class="dls-6"
                    x="90.38"
                    y="524.05"
                    width="97.1"
                    height="49"
                    transform="matrix(1, -0.04, 0.04, 1, -20.39, 5.57)"
                />
                <rect
                    style="display: none"
                    id="rendszam-46"
                    class="dls-5"
                    x="91.92"
                    y="551.28"
                    width="64.16"
                    height="22.76"
                    transform="translate(-20.73 4.97) rotate(-2.12)"
                />
                <rect
                    id="_47"
                    data-name="47"
                    class="dls-6"
                    x="88.58"
                    y="475.05"
                    width="97.1"
                    height="49"
                    transform="translate(-18.56 5.47) rotate(-2.14)"
                />
                <rect
                    style="display: none"
                    id="rendszam-47"
                    class="dls-5"
                    x="89.94"
                    y="501.95"
                    width="64.16"
                    height="22.76"
                    transform="translate(-18.91 4.87) rotate(-2.12)"
                />
                <rect
                    id="_135"
                    data-name="135"
                    class="dls-6"
                    x="1994.67"
                    y="562.75"
                    width="50.6"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-48"
                    class="dls-5"
                    x="1996.34"
                    y="625.64"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_134"
                    data-name="134"
                    class="dls-6"
                    x="1943.97"
                    y="562.75"
                    width="50.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-49"
                    class="dls-5"
                    x="1945.69"
                    y="625.64"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_133"
                    data-name="133"
                    class="dls-6"
                    x="1886.07"
                    y="562.75"
                    width="57.9"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-50"
                    class="dls-5"
                    x="1887.74"
                    y="625.64"
                    width="54.56"
                    height="22.76"
                />
                <rect
                    id="_132"
                    data-name="132"
                    class="dls-6"
                    x="1832.67"
                    y="562.75"
                    width="53.4"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-51"
                    class="dls-5"
                    x="1834.34"
                    y="625.64"
                    width="50.06"
                    height="22.76"
                />
                <rect
                    id="_131"
                    data-name="131"
                    class="dls-6"
                    x="1780.37"
                    y="562.75"
                    width="52.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-52"
                    class="dls-5"
                    x="1782.04"
                    y="625.64"
                    width="48.96"
                    height="22.76"
                />
                <rect
                    id="_130"
                    data-name="130"
                    class="dls-6"
                    x="1731.37"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-53"
                    class="dls-5"
                    x="1733.04"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_129"
                    data-name="129"
                    class="dls-6"
                    x="1682.37"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-54"
                    class="dls-5"
                    x="1684.04"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_128"
                    data-name="128"
                    class="dls-6"
                    x="1633.37"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-55"
                    class="dls-5"
                    x="1635.04"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_127"
                    data-name="127"
                    class="dls-6"
                    x="1584.37"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-56"
                    class="dls-5"
                    x="1586.04"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_126"
                    data-name="126"
                    class="dls-6"
                    x="1535.37"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-57"
                    class="dls-5"
                    x="1537.04"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_125"
                    data-name="125"
                    class="dls-6"
                    x="1486.47"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-58"
                    class="dls-5"
                    x="1488.14"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_124"
                    data-name="124"
                    class="dls-6"
                    x="1437.47"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-59"
                    class="dls-5"
                    x="1439.14"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_123"
                    data-name="123"
                    class="dls-6"
                    x="1388.47"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-60"
                    class="dls-5"
                    x="1390.14"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_122"
                    data-name="122"
                    class="dls-6"
                    x="1339.47"
                    y="562.75"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-61"
                    class="dls-5"
                    x="1341.14"
                    y="625.64"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_121"
                    data-name="121"
                    class="dls-6"
                    x="1486.47"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-62"
                    class="dls-5"
                    x="1488.04"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_120"
                    data-name="120"
                    class="dls-6"
                    x="1535.37"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-63"
                    class="dls-5"
                    x="1537.04"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_119"
                    data-name="119"
                    class="dls-6"
                    x="1584.37"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-64"
                    class="dls-5"
                    x="1586.04"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_118"
                    data-name="118"
                    class="dls-6"
                    x="1633.37"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-65"
                    class="dls-5"
                    x="1635.04"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_117"
                    data-name="117"
                    class="dls-6"
                    x="1633.37"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-66"
                    class="dls-5"
                    x="1635.04"
                    y="345.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_116"
                    data-name="116"
                    class="dls-6"
                    x="1584.37"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-67"
                    class="dls-5"
                    x="1586.04"
                    y="345.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_115"
                    data-name="115"
                    class="dls-6"
                    x="1535.37"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-68"
                    class="dls-5"
                    x="1537.04"
                    y="345.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_114"
                    data-name="114"
                    class="dls-6"
                    x="1486.47"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-69"
                    class="dls-5"
                    x="1488.04"
                    y="345.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_113"
                    data-name="113"
                    class="dls-6"
                    x="2122.17"
                    y="76.45"
                    width="50.6"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-70"
                    class="dls-5"
                    x="2123.84"
                    y="150.79"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_112"
                    data-name="112"
                    class="dls-6"
                    x="2074.77"
                    y="76.45"
                    width="47.3"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-71"
                    class="dls-5"
                    x="2076.44"
                    y="150.79"
                    width="43.96"
                    height="22.76"
                />
                <rect
                    id="_111"
                    data-name="111"
                    class="dls-6"
                    x="2020.27"
                    y="76.45"
                    width="54.5"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-72"
                    class="dls-5"
                    x="2021.94"
                    y="150.79"
                    width="51.16"
                    height="22.76"
                />
                <rect
                    id="_110"
                    data-name="110"
                    class="dls-6"
                    x="1973.47"
                    y="76.45"
                    width="46.8"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-73"
                    class="dls-5"
                    x="1975.14"
                    y="150.79"
                    width="43.46"
                    height="22.76"
                />
                <rect
                    id="_109"
                    data-name="109"
                    class="dls-6"
                    x="1924.47"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-74"
                    class="dls-5"
                    x="1926.14"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_108"
                    data-name="108"
                    class="dls-6"
                    x="1875.57"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-75"
                    class="dls-5"
                    x="1877.24"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_107"
                    data-name="107"
                    class="dls-6"
                    x="1826.57"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-76"
                    class="dls-5"
                    x="1828.24"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_106"
                    data-name="106"
                    class="dls-6"
                    x="1777.57"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-77"
                    class="dls-5"
                    x="1779.24"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_105"
                    data-name="105"
                    class="dls-6"
                    x="1728.57"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-78"
                    class="dls-5"
                    x="1730.24"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_104"
                    data-name="104"
                    class="dls-6"
                    x="1679.57"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-79"
                    class="dls-5"
                    x="1681.24"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_103"
                    data-name="103"
                    class="dls-6"
                    x="1630.57"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-80"
                    class="dls-5"
                    x="1632.24"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_102"
                    data-name="102"
                    class="dls-6"
                    x="1578.27"
                    y="76.45"
                    width="52.3"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-81"
                    class="dls-5"
                    x="1579.94"
                    y="150.79"
                    width="48.96"
                    height="22.76"
                />
                <rect
                    id="_101"
                    data-name="101"
                    class="dls-6"
                    x="1532.67"
                    y="76.45"
                    width="45.6"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-82"
                    class="dls-5"
                    x="1534.34"
                    y="150.79"
                    width="42.26"
                    height="22.76"
                />
                <rect
                    id="_100"
                    data-name="100"
                    class="dls-6"
                    x="1483.67"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-83"
                    class="dls-5"
                    x="1485.34"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_99"
                    data-name="99"
                    class="dls-6"
                    x="1434.67"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-84"
                    class="dls-5"
                    x="1436.34"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_98"
                    data-name="98"
                    class="dls-6"
                    x="1385.67"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-85"
                    class="dls-5"
                    x="1387.34"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_97"
                    data-name="97"
                    class="dls-6"
                    x="1334.97"
                    y="76.45"
                    width="50.7"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-86"
                    class="dls-5"
                    x="1336.74"
                    y="150.79"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_96"
                    data-name="96"
                    class="dls-6"
                    x="1290.27"
                    y="76.45"
                    width="44.8"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-87"
                    class="dls-5"
                    x="1291.94"
                    y="150.79"
                    width="41.46"
                    height="22.76"
                />
                <rect
                    id="_95"
                    data-name="95"
                    class="dls-6"
                    x="1239.07"
                    y="76.45"
                    width="51.2"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-88"
                    class="dls-5"
                    x="1240.74"
                    y="150.79"
                    width="47.86"
                    height="22.76"
                />
                <rect
                    id="_94"
                    data-name="94"
                    class="dls-6"
                    x="1192.27"
                    y="76.45"
                    width="46.8"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-89"
                    class="dls-5"
                    x="1193.94"
                    y="150.79"
                    width="43.46"
                    height="22.76"
                />
                <rect
                    id="_93"
                    data-name="93"
                    class="dls-6"
                    x="1143.27"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-90"
                    class="dls-5"
                    x="1145.04"
                    y="150.79"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_92"
                    data-name="92"
                    class="dls-6"
                    x="1094.37"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-91"
                    class="dls-5"
                    x="1096.14"
                    y="150.79"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_91"
                    data-name="91"
                    class="dls-6"
                    x="1045.37"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-92"
                    class="dls-5"
                    x="1047.24"
                    y="150.79"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_90"
                    data-name="90"
                    class="dls-6"
                    x="999.77"
                    y="76.45"
                    width="45.6"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-93"
                    class="dls-5"
                    x="1001.34"
                    y="150.79"
                    width="42.46"
                    height="22.76"
                />
                <rect
                    id="_89"
                    data-name="89"
                    class="dls-6"
                    x="950.67"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-94"
                    class="dls-5"
                    x="952.44"
                    y="150.79"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_88"
                    data-name="88"
                    class="dls-6"
                    x="898.47"
                    y="76.45"
                    width="52.3"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-95"
                    class="dls-5"
                    x="900.04"
                    y="150.79"
                    width="49.16"
                    height="22.76"
                />
                <rect
                    id="_87"
                    data-name="87"
                    class="dls-6"
                    x="849.37"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-96"
                    class="dls-5"
                    x="851.14"
                    y="150.79"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_86"
                    data-name="86"
                    class="dls-6"
                    x="803.87"
                    y="76.45"
                    width="45.6"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-97"
                    class="dls-5"
                    x="805.44"
                    y="150.79"
                    width="42.46"
                    height="22.76"
                />
                <rect
                    id="_85"
                    data-name="85"
                    class="dls-6"
                    x="754.77"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-98"
                    class="dls-5"
                    x="756.44"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_84"
                    data-name="84"
                    class="dls-6"
                    x="705.77"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-99"
                    class="dls-5"
                    x="707.44"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_83"
                    data-name="83"
                    class="dls-6"
                    x="656.77"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-100"
                    class="dls-5"
                    x="658.44"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_82"
                    data-name="82"
                    class="dls-6"
                    x="607.87"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-101"
                    class="dls-5"
                    x="609.44"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_81"
                    data-name="81"
                    class="dls-6"
                    x="558.87"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-102"
                    class="dls-5"
                    x="560.44"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_80"
                    data-name="80"
                    class="dls-6"
                    x="509.87"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-103"
                    class="dls-5"
                    x="511.44"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_79"
                    data-name="79"
                    class="dls-6"
                    x="457.57"
                    y="76.45"
                    width="52.3"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-104"
                    class="dls-5"
                    x="459.24"
                    y="150.79"
                    width="48.86"
                    height="22.76"
                />
                <rect
                    id="_78"
                    data-name="78"
                    class="dls-6"
                    x="411.97"
                    y="76.45"
                    width="45.6"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-105"
                    class="dls-5"
                    x="413.54"
                    y="150.79"
                    width="42.46"
                    height="22.76"
                />
                <rect
                    id="_77"
                    data-name="77"
                    class="dls-6"
                    x="362.87"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-106"
                    class="dls-5"
                    x="364.54"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_76"
                    data-name="76"
                    class="dls-6"
                    x="317.27"
                    y="76.45"
                    width="45.6"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-107"
                    class="dls-5"
                    x="318.94"
                    y="150.79"
                    width="42.26"
                    height="22.76"
                />
                <rect
                    id="_75"
                    data-name="75"
                    class="dls-6"
                    x="264.97"
                    y="76.45"
                    width="52.3"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-108"
                    class="dls-5"
                    x="266.64"
                    y="150.79"
                    width="48.96"
                    height="22.76"
                />
                <rect
                    id="_74"
                    data-name="74"
                    class="dls-6"
                    x="215.97"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-109"
                    class="dls-5"
                    x="217.64"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_73"
                    data-name="73"
                    class="dls-6"
                    x="166.97"
                    y="76.45"
                    width="49"
                    height="97.1"
                />
                <rect
                    style="display: none"
                    id="rendszam-110"
                    class="dls-5"
                    x="168.64"
                    y="150.79"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_72"
                    data-name="72"
                    class="dls-6"
                    x="851.87"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-111"
                    class="dls-5"
                    x="853.54"
                    y="345.34"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_71"
                    data-name="71"
                    class="dls-6"
                    x="802.87"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-112"
                    class="dls-5"
                    x="804.54"
                    y="345.34"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_70"
                    data-name="70"
                    class="dls-6"
                    x="753.97"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-113"
                    class="dls-5"
                    x="755.64"
                    y="345.34"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_69"
                    data-name="69"
                    class="dls-6"
                    x="704.97"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-114"
                    class="dls-5"
                    x="706.74"
                    y="345.34"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_68"
                    data-name="68"
                    class="dls-6"
                    x="655.97"
                    y="282.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-115"
                    class="dls-5"
                    x="657.84"
                    y="345.34"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_67"
                    data-name="67"
                    class="dls-6"
                    x="851.87"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-116"
                    class="dls-5"
                    x="853.54"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_66"
                    data-name="66"
                    class="dls-6"
                    x="802.87"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-117"
                    class="dls-5"
                    x="804.54"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_65"
                    data-name="65"
                    class="dls-6"
                    x="753.97"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-118"
                    class="dls-5"
                    x="755.64"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_64"
                    data-name="64"
                    class="dls-6"
                    x="704.97"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-119"
                    class="dls-5"
                    x="706.74"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_63"
                    data-name="63"
                    class="dls-6"
                    x="655.97"
                    y="368.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-120"
                    class="dls-5"
                    x="657.84"
                    y="431.09"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_62"
                    data-name="62"
                    class="dls-6"
                    x="1046.07"
                    y="563.15"
                    width="50.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-121"
                    class="dls-5"
                    x="1047.74"
                    y="626.1"
                    width="47.36"
                    height="22.76"
                />
                <rect
                    id="_61"
                    data-name="61"
                    class="dls-6"
                    x="998.87"
                    y="563.15"
                    width="47.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-122"
                    class="dls-5"
                    x="1000.54"
                    y="626.1"
                    width="43.96"
                    height="22.76"
                />
                <rect
                    id="_60"
                    data-name="60"
                    class="dls-6"
                    x="950.97"
                    y="563.15"
                    width="47.9"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-123"
                    class="dls-5"
                    x="952.94"
                    y="626.1"
                    width="43.96"
                    height="22.76"
                />
                <rect
                    id="_59"
                    data-name="59"
                    class="dls-6"
                    x="900.87"
                    y="563.15"
                    width="50.1"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-124"
                    class="dls-5"
                    x="902.54"
                    y="626.1"
                    width="46.76"
                    height="22.76"
                />
                <rect
                    id="_58"
                    data-name="58"
                    class="dls-6"
                    x="851.87"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-125"
                    class="dls-5"
                    x="853.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_57"
                    data-name="57"
                    class="dls-6"
                    x="802.87"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-126"
                    class="dls-5"
                    x="804.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_56"
                    data-name="56"
                    class="dls-6"
                    x="753.97"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-127"
                    class="dls-5"
                    x="755.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_55"
                    data-name="55"
                    class="dls-6"
                    x="704.97"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-128"
                    class="dls-5"
                    x="706.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_54"
                    data-name="54"
                    class="dls-6"
                    x="655.97"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-129"
                    class="dls-5"
                    x="657.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_53"
                    data-name="53"
                    class="dls-6"
                    x="606.97"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-130"
                    class="dls-5"
                    x="608.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_52"
                    data-name="52"
                    class="dls-6"
                    x="557.97"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-131"
                    class="dls-5"
                    x="559.54"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_51"
                    data-name="51"
                    class="dls-6"
                    x="496.27"
                    y="563.15"
                    width="61.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-132"
                    class="dls-5"
                    x="498.04"
                    y="626.1"
                    width="58.16"
                    height="22.76"
                />
                <rect
                    id="_50"
                    data-name="50"
                    class="dls-6"
                    x="432.07"
                    y="563.15"
                    width="64.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-133"
                    class="dls-5"
                    x="433.74"
                    y="626.1"
                    width="60.78"
                    height="22.76"
                />
                <rect
                    id="_49"
                    data-name="49"
                    class="dls-6"
                    x="383.07"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-134"
                    class="dls-5"
                    x="384.74"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_48"
                    data-name="48"
                    class="dls-6"
                    x="334.07"
                    y="563.15"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-135"
                    class="dls-5"
                    x="335.74"
                    y="626.1"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_136"
                    data-name="136"
                    class="dls-6"
                    x="2182.37"
                    y="452.91"
                    width="97.1"
                    height="49"
                    transform="translate(-17.83 92.66) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-136"
                    class="dls-5"
                    x="2183.36"
                    y="478.91"
                    width="64.16"
                    height="22.76"
                    transform="translate(-18.59 93.2) rotate(-2.4)"
                />
                <rect
                    id="_137"
                    data-name="137"
                    class="dls-6"
                    x="2184.37"
                    y="501.9"
                    width="97.1"
                    height="49"
                    transform="translate(-19.86 92.79) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-137"
                    class="dls-5"
                    x="2185.41"
                    y="527.87"
                    width="64.16"
                    height="22.76"
                    transform="translate(-20.64 93.33) rotate(-2.4)"
                />
                <rect
                    id="_138"
                    data-name="138"
                    class="dls-6"
                    x="2186.37"
                    y="550.81"
                    width="97.1"
                    height="49"
                    transform="translate(-21.88 92.91) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-138"
                    class="dls-5"
                    x="2187.47"
                    y="576.82"
                    width="64.16"
                    height="22.76"
                    transform="translate(-22.68 93.46) rotate(-2.4)"
                />
                <rect
                    id="_139"
                    data-name="139"
                    class="dls-6"
                    x="2188.38"
                    y="599.7"
                    width="97.1"
                    height="49"
                    transform="translate(-23.9 93.04) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-139"
                    class="dls-5"
                    x="2189.54"
                    y="626.78"
                    width="64.16"
                    height="22.76"
                    transform="translate(-24.77 93.59) rotate(-2.4)"
                />
                <rect
                    id="_140"
                    data-name="140"
                    class="dls-6"
                    x="2190.47"
                    y="648.7"
                    width="97.1"
                    height="49"
                    transform="translate(-25.92 93.16) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-140"
                    class="dls-5"
                    x="2191.58"
                    y="674.73"
                    width="64.16"
                    height="22.76"
                    transform="translate(-26.78 93.72) rotate(-2.4)"
                />
                <rect
                    id="_141"
                    data-name="141"
                    class="dls-6"
                    x="2192.47"
                    y="697.64"
                    width="97.09"
                    height="48.94"
                    transform="translate(-27.06 90.12) rotate(-2.29)"
                />
                <rect
                    style="display: none"
                    id="rendszam-141"
                    class="dls-5"
                    x="2193.64"
                    y="723.69"
                    width="64.16"
                    height="22.76"
                    transform="translate(-28.83 93.85) rotate(-2.4)"
                />
                <rect
                    id="_142"
                    data-name="142"
                    class="dls-6"
                    x="2194.47"
                    y="746.59"
                    width="97.1"
                    height="49"
                    transform="translate(-29.97 93.41) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-142"
                    class="dls-5"
                    x="2195.69"
                    y="772.64"
                    width="64.16"
                    height="22.76"
                    transform="translate(-30.88 93.98) rotate(-2.4)"
                />
                <rect
                    id="_143"
                    data-name="143"
                    class="dls-6"
                    x="2196.57"
                    y="795.49"
                    width="97.1"
                    height="52.3"
                    transform="translate(-32.06 93.54) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-143"
                    class="dls-5"
                    x="2197.75"
                    y="824.81"
                    width="64.16"
                    height="22.76"
                    transform="translate(-33.06 94.11) rotate(-2.4)"
                />
                <rect
                    id="_144"
                    data-name="144"
                    class="dls-6"
                    x="2198.68"
                    y="847.79"
                    width="97.1"
                    height="49"
                    transform="translate(-34.15 93.67) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-144"
                    class="dls-5"
                    x="2200.81"
                    y="874.55"
                    width="64.16"
                    height="22.76"
                    transform="translate(-35.14 94.28) rotate(-2.4)"
                />
                <rect
                    id="_145"
                    data-name="145"
                    class="dls-6"
                    x="2200.67"
                    y="896.79"
                    width="97.1"
                    height="45.6"
                    transform="translate(-36.1 93.8) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-145"
                    class="dls-5"
                    x="2201.87"
                    y="920.51"
                    width="64.16"
                    height="22.76"
                    transform="translate(-37.06 94.37) rotate(-2.4)"
                />
                <rect
                    id="_146"
                    data-name="146"
                    class="dls-6"
                    x="2202.67"
                    y="942.43"
                    width="97.2"
                    height="52.4"
                    transform="translate(-36.91 90.73) rotate(-2.29)"
                />
                <rect
                    style="display: none"
                    id="rendszam-146"
                    class="dls-5"
                    x="2203.92"
                    y="972.46"
                    width="64.16"
                    height="22.76"
                    transform="translate(-39.24 94.5) rotate(-2.4)"
                />
                <rect
                    id="_147"
                    data-name="147"
                    class="dls-6"
                    x="2204.67"
                    y="994.63"
                    width="97.2"
                    height="45.7"
                    transform="translate(-38.86 90.85) rotate(-2.29)"
                />
                <rect
                    style="display: none"
                    id="rendszam-147"
                    class="dls-5"
                    x="2205.97"
                    y="1017.41"
                    width="64.16"
                    height="22.76"
                    transform="translate(-41.12 94.62) rotate(-2.4)"
                />
                <rect
                    id="_148"
                    data-name="148"
                    class="dls-6"
                    x="2206.67"
                    y="1040.19"
                    width="97.1"
                    height="49"
                    transform="translate(-42.1 94.17) rotate(-2.37)"
                />
                <rect
                    style="display: none"
                    id="rendszam-148"
                    class="dls-5"
                    x="2208.03"
                    y="1066.37"
                    width="64.16"
                    height="22.76"
                    transform="translate(-43.17 94.75) rotate(-2.4)"
                />
                <rect
                    id="_149"
                    data-name="149"
                    class="dls-6"
                    x="1994.67"
                    y="648.45"
                    width="50.6"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-149"
                    class="dls-5"
                    x="1996.34"
                    y="711.39"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_150"
                    data-name="150"
                    class="dls-6"
                    x="1943.97"
                    y="648.45"
                    width="50.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-150"
                    class="dls-5"
                    x="1945.69"
                    y="711.39"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_151"
                    data-name="151"
                    class="dls-6"
                    x="1886.07"
                    y="648.45"
                    width="57.9"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-151"
                    class="dls-5"
                    x="1887.74"
                    y="711.39"
                    width="54.56"
                    height="22.76"
                />
                <rect
                    id="_152"
                    data-name="152"
                    class="dls-6"
                    x="1832.67"
                    y="648.45"
                    width="53.4"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-152"
                    class="dls-5"
                    x="1834.34"
                    y="711.39"
                    width="50.06"
                    height="22.76"
                />
                <rect
                    id="_153"
                    data-name="153"
                    class="dls-6"
                    x="1780.37"
                    y="648.45"
                    width="52.3"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-153"
                    class="dls-5"
                    x="1782.04"
                    y="711.39"
                    width="48.96"
                    height="22.76"
                />
                <rect
                    id="_154"
                    data-name="154"
                    class="dls-6"
                    x="1731.37"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-154"
                    class="dls-5"
                    x="1733.04"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_155"
                    data-name="155"
                    class="dls-6"
                    x="1682.37"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-155"
                    class="dls-5"
                    x="1684.04"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_156"
                    data-name="156"
                    class="dls-6"
                    x="1633.37"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-156"
                    class="dls-5"
                    x="1635.04"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_157"
                    data-name="157"
                    class="dls-6"
                    x="1584.37"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-157"
                    class="dls-5"
                    x="1586.04"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_158"
                    data-name="158"
                    class="dls-6"
                    x="1535.37"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-158"
                    class="dls-5"
                    x="1537.04"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_159"
                    data-name="159"
                    class="dls-6"
                    x="1486.47"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-159"
                    class="dls-5"
                    x="1488.14"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_160"
                    data-name="160"
                    class="dls-6"
                    x="1437.47"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-160"
                    class="dls-5"
                    x="1439.14"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_161"
                    data-name="161"
                    class="dls-6"
                    x="1388.47"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-161"
                    class="dls-5"
                    x="1390.14"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_162"
                    data-name="162"
                    class="dls-6"
                    x="1339.47"
                    y="648.45"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-162"
                    class="dls-5"
                    x="1341.14"
                    y="711.39"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_163"
                    data-name="163"
                    class="dls-6"
                    x="2001.37"
                    y="846.25"
                    width="50.6"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-163"
                    class="dls-5"
                    x="2003.04"
                    y="909.19"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_164"
                    data-name="164"
                    class="dls-6"
                    x="1950.67"
                    y="846.25"
                    width="50.7"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-164"
                    class="dls-5"
                    x="1952.39"
                    y="909.19"
                    width="47.26"
                    height="22.76"
                />
                <rect
                    id="_165"
                    data-name="165"
                    class="dls-6"
                    x="1892.77"
                    y="846.25"
                    width="57.9"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-165"
                    class="dls-5"
                    x="1894.44"
                    y="909.19"
                    width="54.56"
                    height="22.76"
                />
                <rect
                    id="_166"
                    data-name="166"
                    class="dls-6"
                    x="1829.27"
                    y="846.25"
                    width="63.5"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-166"
                    class="dls-5"
                    x="1831.04"
                    y="909.19"
                    width="59.96"
                    height="22.76"
                />
                <rect
                    id="_167"
                    data-name="167"
                    class="dls-6"
                    x="1780.37"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-167"
                    class="dls-5"
                    x="1782.04"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_168"
                    data-name="168"
                    class="dls-6"
                    x="1731.37"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-168"
                    class="dls-5"
                    x="1733.53"
                    y="909.19"
                    width="44.67"
                    height="22.76"
                />
                <rect
                    id="_169"
                    data-name="169"
                    class="dls-6"
                    x="1682.37"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-169"
                    class="dls-5"
                    x="1684.04"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_170"
                    data-name="170"
                    class="dls-6"
                    x="1633.37"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-170"
                    class="dls-5"
                    x="1635.04"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_171"
                    data-name="171"
                    class="dls-6"
                    x="1584.37"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-171"
                    class="dls-5"
                    x="1586.04"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_172"
                    data-name="172"
                    class="dls-6"
                    x="1535.37"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-172"
                    class="dls-5"
                    x="1537.04"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_173"
                    data-name="173"
                    class="dls-6"
                    x="1486.47"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-173"
                    class="dls-5"
                    x="1488.14"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_174"
                    data-name="174"
                    class="dls-6"
                    x="1437.47"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-174"
                    class="dls-5"
                    x="1439.14"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_175"
                    data-name="175"
                    class="dls-6"
                    x="1388.47"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-175"
                    class="dls-5"
                    x="1390.14"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_176"
                    data-name="176"
                    class="dls-6"
                    x="1339.47"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-176"
                    class="dls-5"
                    x="1341.14"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_177"
                    data-name="177"
                    class="dls-6"
                    x="1290.47"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-177"
                    class="dls-5"
                    x="1292.14"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_178"
                    data-name="178"
                    class="dls-6"
                    x="1241.47"
                    y="846.25"
                    width="49"
                    height="85.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-178"
                    class="dls-5"
                    x="1243.14"
                    y="909.19"
                    width="45.66"
                    height="22.76"
                />
            </g>
            <path
                id="hatterelem2"
                class="dls-1"
                d="M1579.77,1018l-6-941,10-.06,6,941Zm-821,19,1-960h-10l-1,960Z"
            />
            <path
                id="oszlopok"
                class="dls-7"
                d="M2191.77,192.65h-38v-38h38Zm2,138.6h-38v-38h38Zm5.5,95.5h-38v-38h38Zm5.1,145.2h-38V534h38Zm4.8,150.1h-38v-38h38Zm5.7,143h-38v-38h38ZM2058,577h-38V539h38Zm-797.4,2.1h-38v-38h38Zm-145.3,0h-38v-38h38Zm-762.2,5.8h-38v-38h38Zm0,149.7h-38v-38h38Zm9.3,144.1h-38v-38h38Zm0,144.1h-38v-38h38Zm752.9-295.9h-38v-38h38Zm393.3-142h-44.4v-44.4h44.4v44.4Zm0,292.9h-44.4v-44.4h44.4Zm0,143.3h-44.4v-44.4h44.4Zm-632.2-436.2H832v-44.4h44.4Zm-198.2,0h-44.4v-44.4h44.4Zm198.2,148.5H832V689h44.4Zm0,148.5H832v-44.4h44.4Zm0,140.3H832v-44.4h44.4Zm-198.2-288.8h-44.4V689h44.4Zm-98-148.5h-44.4v-44.4h44.4Zm1124.4-2.7h-44.4v-44.4h44.4Zm97.9,2.7h-44.4v-44.4h44.4Zm-541.9,142h-38v-38h38Zm-145.3,147.8h-38v-38h38Zm145.3,0h-38v-38h38ZM1115.27,1019h-38V981h38Zm145.3,0h-38V981h38Zm778.7-826.3h-38v-38h38Zm-95.7,0h-38v-38h38Zm-147,0h-38v-38h38Zm0,144.9h-38v-38h38Zm-97.9-144.9h-38v-38h38Zm0,144.9h-38v-38h38Zm-196-144.9h-38v-38h38Zm-148.6,0h-38v-38h38Zm-96,0h-38v-38h38Zm-144.7,0h-38v-38h38Zm-94.6,0h-38v-38h38Zm-150.3,0h-38v-38h38Zm-192.6,0h-38v-38h38Zm0,146.8h-38v-38h38Zm197.4,0h-38v-38h38Zm-295.4-146.8h-38v-38h38Zm-146.9,0H393v-38h38Zm-94.7,0h-38v-38h38Zm-150.3,0H148v-38h38Z"
            />
            <path
                id="line-grid"
                class="dls-5"
                d="M1924,732.48h18.33V714.05h3.34v18.43h18.43v3.34H1924ZM1831,912h-3.34v18.33h-18.43v3.34h40.1v-3.34H1831Zm-49-283.6h-3.34v18.43h-18.43v3.34h18.43v18.33H1782V650.12h18.33v-3.34H1782Zm-98,0h-3.34v18.43h-18.33v3.34h18.33v18.33H1684V650.12h18.33v-3.34H1684Zm98,85.7h-3.34v18.43h-18.43v3.34h40.1v-3.34H1782ZM1760.27,848h18.43v18.43H1782V848h18.33v-3.34h-40.1Zm-49,0h18.43v18.43H1733V848h18.33v-3.34h-40.1ZM1733,628.38h-3.34v18.43h-18.43v3.34h18.43v18.3H1733V650.12h18.33v-3.34H1733Zm0,283.6h-3.34v18.33h-18.43v3.34h40.1v-3.34H1733Zm0-197.9h-3.34v18.43h-18.43v3.34h40.1v-3.34H1733ZM1782,912h-3.34v18.33h-18.43v3.34h40.1v-3.34H1782Zm90.73-64h18.33v18.43h3.34V848h18.33v-3.34h-40Zm21.67,64h-3.34v18.33h-18.33v3.34h40v-3.34h-18.33Zm51.2-329.2V564.32h18.43V561H1924v3.34h18.33v18.46Zm-79.57,153h40.1v-3.34h-18.4V714.05h-3.34v18.43h-18.36Zm57.9-85.7h18.33v18.33h3.34V650.12h18.43v-3.34h-18.43V628.35h-3.34v18.43H1924Zm-89.63-21.77H1831v18.43h-18.33v3.34H1831v18.33h3.34V650.12h18.33v-3.34h-18.33Zm0,85.7H1831v18.43h-18.33v3.34h40v-3.34h-18.33ZM1809.27,848h18.43v18.43H1831V848h18.33v-3.34h-40.1Zm56.8-197.8h18.33v18.3h3.37V650.12h18.43v-3.34h-18.43V628.35h-3.34v18.43h-18.36Zm21.7-67.4V564.32h18.43V561h-40.1v3.34h18.33v18.46ZM1613.37,848h18.33v18.43H1635V848h18.43v-3.34h-40.1ZM1586,714.05h-3.34v18.43h-18.33v3.34h40.1v-3.34H1586Zm0-85.7h-3.34v18.43h-18.33v3.34h18.33v18.33H1586V650.12h18.43v-3.34H1586Zm-21.67-64h18.33v18.4H1586V564.32h18.43V561h-40.1Zm0,283.6h18.33v18.43H1586V848h18.43v-3.34h-40.1ZM1586,433.88h-3.34v18.33h-18.33v3.34h40.1v-3.34H1586Zm0-85.8h-3.34v18.43h-18.33v3.34h18.33v18.3H1586V369.82h18.43v-3.34H1586Zm0,563.9h-3.34v18.33h-18.33v3.34h40.1v-3.34H1586Zm-48.9-478.1h-3.37v18.33h-18.4v3.34h40.1v-3.34h-18.33Zm-21.77,130.44h18.4v18.43h3.34V564.32h18.33V561h-40.1ZM1684,714.05h-3.34v18.43h-18.33v3.34h40v-3.34H1684Zm-146.9-366h-3.37v18.43h-18.4v3.34h18.4v18.33h3.34V369.82h18.33v-3.34h-18.33Zm97.9,0h-3.34v18.43h-18.33v3.34h18.33v18.33H1635V369.82h18.43v-3.34H1635ZM1684,912h-3.34v18.33h-18.33v3.34h40v-3.34H1684Zm-21.67-64h18.33v18.43H1684V848h18.33v-3.34h-40ZM1635,433.85h-3.34v18.33h-18.33v3.34h40.1v-3.34H1635Zm0,280.2h-3.34v18.43h-18.33v3.34h40.1v-3.34H1635Zm-21.67-149.73h18.33v18.43H1635V564.32h18.43V561h-40.1ZM1635,912h-3.34v18.33h-18.33v3.34h40.1v-3.34H1635Zm317.3,0H1949v18.33h-18.33v3.34h40v-3.34h-18.33ZM1635,628.35h-3.34v18.43h-18.33v3.34h18.33v18.33H1635V650.12h18.43v-3.34H1635Zm569.6,348.13-3.34.14,1.6,40,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.33.73Zm-4.1-97.9-3.34.14.73,18.33h0l.14,3.34h0l.82,18.34,3.34-.15-.83-18.33,18.43-.73-.14-3.34-18.43.73Zm-2-49-3.34.14.74,18.43h0l.87,21.67,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.33.73Zm-4.2-101.2-3.34.14,1.6,40.1,3.34-.14-.73-18.43,18.33-.73-.14-3.34-18.33.73Zm2,49-3.34.14.73,18.33h0l.14,3.34h0l.82,18.35,3.34-.16-.83-18.32,18.43-.73-.14-3.34-18.43.73Zm6.1,146.8-3.34.14,1.6,40,3.34-.14-.73-18.33,18.43-.73-.14-3.34-18.43.73Zm-10.1-244.7-3.34.14,1.6,40,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.33.73Zm16.2,391.5-3.34.14.87,21.67,21.7-.84-.14-3.34-18.33.73Zm70.1-572.82-18.35.82.16,3.34,18.32-.83.73,18.33,3.34-.14-1.6-40-3.34.14Zm-1.87-45.57.73,18.33,3.34-.14-.87-21.66-21.67.86.14,3.34Zm-70.33,569.49-3.34.15.9,20,.8,20,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.34.73Zm-669.3-393.73h-3.37v18.43h-18.4v3.34h18.4v18.33h3.34V650.12h18.33v-3.34h-18.33ZM2120.5,96.55h3.34V78.12h18.33V74.78h-40.1v3.34h18.43Zm53.94,57h-3.34v18.33h-18.33v3.34h21.67ZM1930.67,848H1949v18.43h3.34V848h18.33v-3.34h-40Zm211.5-676h-18.33v-18.4h-3.34v18.33h-18.43v3.34h40.1Zm42,311.79-3.34.16.9,20,.8,20.09,3.34-.14-.74-18.43,18.34-.73-.14-3.34-18.34.73Zm4.1,97.91-3.34.14.73,18.33h0l1,21.68,3.34-.15-.83-18.33,18.33-.73-.14-3.34L2189,600Zm-4.4-106.8-.83-18.33,18.33-.73-.14-3.34-21.67.87,1,21.68Zm2.4,57.9-3.34.14,1.6,40,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.33.73Zm4,97.9-3.34.14.74,18.34h0l.14,3.33h0l.82,18.34,3.34-.15-.83-18.34,18.43-.82-.14-3.34L2191,649Zm-19.14-534h3.34V74.78h-21.7v3.34h18.33Zm-124.19,571.8v-40.1h-3.34v18.43h-18.33v3.34h18.33v18.33Zm-21.67,67.37h21.67V714.05h-3.34v18.43h-18.33Zm275.66,300.73-18.33.73.14,3.34,18.34-.73.82,18.34,3.34-.15-.9-20-.8-20-3.34.14ZM2050.3,930.28H2032v3.34h21.67V912h-3.34ZM2303,1085.46l-18.43.82.14,3.34,21.77-1-1-21.67-3.34.16ZM1981.27,848h18.43v18.43H2003V848h18.33v-3.34h-40.1Zm-6.7-197.8H1993v18.3h3.34V650.12h18.33v-3.34h-18.33V628.35H1993v18.43h-18.43Zm21.77-67.37V564.32h18.33V561h-40.1v3.34H1993v18.46Zm-21.77,153h40.1v-3.34h-18.33V714.05H1993v18.43h-18.43ZM2003,912h-3.34v18.33h-18.43v3.34h40.1v-3.34H2003Zm293.89,26.7-18.33.73.14,3.34,18.33-.73.73,18.33,3.34-.14-.73-18.33h0l-1-21.68-3.34.16ZM2299,991l-18.33.73.14,3.34,18.34-.74.82,18.35,3.34-.16-.9-20-.8-20.09-3.34.14Zm-14.26-345.9-18.33.73.14,3.34,18.33-.73.73,18.33,3.34-.14-1.6-40.1-3.34.14Zm2,48.9-18.33.73.14,3.34,18.34-.74.82,18.35,3.34-.16-.9-20-.8-20-3.34.14Zm-4-97.9-18.43.73.14,3.34,18.43-.73.73,18.33,3.34-.14-.73-18.33h0l-.14-3.34h0l-.82-18.34-3.34.15ZM2073.1,96.55h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm207.54,450.6-18.34.73.14,3.34,18.34-.73.82,18.34,3.34-.16-.9-20-.8-20.09-3.34.14Zm10.19,244.7-18.33.73.14,3.34,18.33-.73.73,18.33,3.34-.14-.73-18.33h0l-1-21.68-3.34.16Zm4.2,101.2-18.33.73.14,3.34,18.33-.73.73,18.33,3.34-.14-.73-18.33h0l-.14-3.34h0l-.82-18.34-3.34.15Zm-2.09-49-18.35.82.15,3.34,18.34-.83.82,18.43,3.34-.14-.9-20.1-.8-20-3.34.14Zm-4.17-101.19-18.33.82.15,3.34,18.33-.83.82,18.34,3.34-.16-.9-20-.8-20-3.34.14ZM421.37,850.22H439.7v18.33H443V850.22h18.33v-3.34h-40ZM498,583.15V564.72h18.33v-3.34h-40.1v3.34H494.7v18.43ZM372.37,850.22H390.7v18.33H394V850.22h18.33v-3.34h-40Zm103.9-199.7H494.7v18.33H498V650.52h18.33v-3.34H498V628.75H494.7v18.43H476.27ZM443,914.15H439.7v18.43H421.37V936H439.7v18.33H443V936h18.33v-3.34H443Zm-9.3-331V564.72h18.33v-3.34H412v3.34H430.4v18.43ZM412,650.52H430.4v18.33h3.37V650.52h18.3v-3.34h-18.3V628.75h-3.34v18.43H412Zm95.33,367.76H489v3.34h21.67V1000H507.3ZM443,1000H439.7v18.33H421.37v3.34h40v-3.34H443ZM412,736.22h40.1v-3.34h-18.3V714.45h-3.34v18.43H412Zm64.3,0h40.1v-3.34H498V714.45H494.7v18.43H476.27Zm377.27-21.77H850.2v18.43H831.87v3.34H872v-3.34H853.54ZM831.87,850.22H850.2v18.33h3.34V850.22H872v-3.34h-40.1Zm0-285.5H850.2v18.43h3.34V564.72H872v-3.34h-40.1Zm21.67,349.43H850.2v18.43H831.87V936H872v-3.34H853.54Zm0-285.4H850.2v18.43H831.87v3.34H850.2v18.33h3.34V650.52H872v-3.34H853.54Zm-195.9-194.9H654.3v21.67H676v-3.34H657.64ZM489,850.22H507.3v18.33h3.34V850.22h18.43v-3.34H489Zm21.67,63.93H507.3v18.43H489V936H507.3v18.33h3.34V936h18.43v-3.34H510.64Zm147-566.1H654.3v40.1h3.34V369.82H676v-3.34H657.64Zm-3.34-45.6h3.34V284.12H676v-3.34H654.3ZM203.9,1031.82l3.34-.14-.8-20-.7-20-3.34.12.64,18.33-18.33.64.12,3.34,18.34-.64Zm1.8,49,3.34-.12-.64-18.44h0l-.13-3.34h0l-.73-18.34-3.34.14.74,18.33-18.44.73.14,3.34,18.42-.73Zm-3.7-97.9,3.34-.12-.64-18.44h0l-.76-21.66-3.34.12.64,18.34-18.34.73.14,3.34,18.32-.73ZM332.4,668.85h3.37V650.52h18.3v-3.34h-18.3V628.75h-3.34Zm-125,457.56,3.34-.12L210.1,1108h0l-.86-21.78-3.34.14.73,18.42-18.32.64.12,3.34,18.33-.64Zm.5,12.2.64,18.34-18.34.73.14,3.34,21.66-.87-.76-21.66ZM853.54,433.85H850.2v18.33H831.87v3.34H872v-3.34H853.54ZM196.7,839.42l3.34-.14-.8-20.1-.7-20-3.34.12.64,18.34-18.34.73.14,3.34L196,821Zm3.5,94.49,3.34-.12-.64-18.33h0L202,893.78l-3.34.14.74,18.32-18.33.64.12,3.34,18.33-.64Zm-5.3-143.49,3.34-.14-.8-20-.7-20-3.34.12.64,18.33-18.33.64.12,3.34,18.34-.64Zm1342.24-76.37h-3.37v18.43h-18.4v3.34h40.1v-3.34h-18.33ZM345,1000H341.7v21.67h21.77v-3.34H345ZM363,736.22h40.1v-3.34h-18.3V714.45h-3.34v18.43H363Zm0-85.7H381.4v18.33h3.37V650.52h18.3v-3.34h-18.3V628.75h-3.34v18.43H363Zm21.8-67.37V564.72h18.3v-3.34H363v3.34H381.4v18.43Zm9.3,416.8h-3.34v18.33H372.37v3.34h40v-3.34H394Zm-58.3-435.23h18.3v-3.34H332.4v21.77h3.37Zm58.3,349.43h-3.34v18.43H372.37V936H390.7v18.33H394V936h18.33v-3.34H394ZM332.4,736.22h21.67v-3.34h-18.3V714.45h-3.34ZM345,914.15H341.7v40.1H345V936h18.43v-3.34H345Zm-3.34-45.6H345V850.22h18.43v-3.34H341.7ZM198.4,885l3.34-.12-.64-18.44h0l-.12-3.34h0l-.73-18.34-3.34.14.73,18.33-18.43.73.14,3.34,18.42-.73ZM1390.14,628.35h-3.37v18.43h-18.3v3.34h18.3v18.33h3.34V650.12h18.33v-3.34h-18.33Zm49,283.6h-3.37v18.33h-18.3v3.34h40v-3.34h-18.33Zm-21.67-64h18.3v18.43h3.34V848h18.33v-3.34h-40Zm-27.33-133.9h-3.37v18.43h-18.3v3.34h40v-3.34h-18.33Zm49-85.7h-3.37v18.43h-18.3v3.34h18.3v18.33h3.34V650.12h18.33v-3.34h-18.33Zm0,85.7h-3.37v18.43h-18.3v3.34h40v-3.34h-18.33Zm-98,0h-3.37v21.77h21.77v-3.34h-18.43ZM1368.47,848h18.3v18.43h3.34V848h18.33v-3.34h-40Zm-27.33-219.6h-3.37v40.1h3.34V650.12h18.43v-3.34h-18.43Zm49,283.6h-3.37v18.33h-18.3v3.34h40v-3.34h-18.33Zm-70.67-64h18.3v18.43h3.34V848h18.43v-3.34h-40.1Zm168.67,64h-3.37v18.33h-18.4v3.34h40.1v-3.34h-18.33Zm49,0h-3.37v18.33h-18.4v3.34h40.1v-3.34h-18.33Zm-21.77-64h18.4v18.43h3.34V848h18.33v-3.34h-40.1Zm-27.23-414.1h-3.37v21.67h21.67v-3.34h-18.33Zm0-85.8h-3.37v40.1h3.34V369.82h18.33v-3.34h-18.33Zm-21.77,216.27h18.4v18.43h3.34V564.32h18.33V561h-40.1Zm21.77,149.73h-3.37v18.43h-18.4v3.34h40.1v-3.34h-18.33ZM1466.37,848h18.4v18.43h3.34V848h18.33v-3.34h-40.1Zm21.77-219.57h-3.37v18.43h-18.4v3.34h18.4v18.3h3.34V650.12h18.33v-3.34h-18.33ZM1026.07,850.22h18.43v18.33h3.34V850.22h18.33v-3.34h-40.1ZM952.64,714.45H949.3v18.43H931v3.34h40v-3.34H952.64ZM931,850.22H949.3v18.33h3.34V850.22H971v-3.34H931Zm21.67-221.47H949.3v18.43H931v3.34H949.3v18.33h3.34V650.52H971v-3.34H952.64Zm95.2,285.4h-3.34v18.43h-18.43V936h40.1v-3.34h-18.33Zm-95.2,0H949.3v18.43H931V936h40v-3.34H952.64Zm-50.1-285.4H899.2v18.43H880.87v3.34H899.2v18.33h3.34V650.52H921v-3.34H902.54Zm0,285.4H899.2v18.43H880.87V936H921v-3.34H902.54Zm-21.67-63.93H899.2v18.33h3.34V850.22H921v-3.34h-40.1Zm21.67-135.77H899.2v18.43H880.87v3.34H921v-3.34H902.54Zm-49-366.4H850.2v18.43H831.87v3.34H850.2v18.33h3.34V369.82H872v-3.34H853.54ZM1243.14,912h-3.37v21.67h21.77v-3.34h-18.43ZM1076.77,564.72h18.33v18.43h3.34V561.38h-21.67ZM1341.14,912h-3.37v18.33h-18.3v3.34h40.1v-3.34h-18.43Zm-246-264.77h-18.37v3.34h18.33v18.33h3.34v-40.1h-3.34Zm-47.26,67.27h-3.34v18.43h-18.47v3.34h40.1v-3.34h-18.33ZM1292.18,912h-3.41v18.33h-18.3v3.34h40.1v-3.34h-18.43Zm-244.3-283.2h-3.34v18.43h-18.47v3.34h18.43v18.33h3.34V650.52h18.33v-3.34h-18.33Zm47.26,104.13h-18.37v3.34h21.67V714.45h-3.34Zm0,199.7h-18.37V936h21.67v-21.8h-3.34Zm-18.37-82.36h18.33v18.33h3.34V846.88h-21.67ZM183.06,475l.64,18.42,3.34-.12-.76-21.78-21.68.87.14,3.34ZM655.2,96.55h3.34V78.12h18.33V74.78h-40.1v3.34H655.2Zm21.67,75.33H658.54V153.55H655.2v18.33H636.77v3.34h40.1Zm-22.57,497h3.34V650.52H676v-3.34H657.64V628.75H654.3v18.43H636v3.34H654.3ZM725,932.61H706.64V914.15H703.3v18.43H684.87V936H725Zm-49-199.7H657.64V714.45H654.3v18.43H636v3.34h40ZM654.3,583.15h3.34V564.72H676v-3.34H636v3.34H654.3Zm70.67-131H706.64v-18.3H703.3v18.33H684.87v3.34H725ZM703.3,868.55h3.34V850.22H725v-3.34h-40.1v3.34H703.3Zm0-199.7h3.34V650.52H725v-3.34H706.64V628.75H703.3v18.43H684.87v3.34H703.3Zm21.67,64H706.64v-18.4H703.3v18.43H684.87v3.34H725ZM703.3,583.15h3.34V564.72H725v-3.34h-40.1v3.34H703.3ZM627,732.88H608.64V714.45H605.3v18.43H587v3.34h40ZM605.3,868.55h3.34V850.22H627v-3.34H587v3.34H605.3Zm-48.1-772h3.34V78.12h18.33V74.78h-40v3.34H557.2Zm69.77,836H608.64v-18.4H605.3v18.43H587V936h40ZM605.3,668.85h3.34V650.52H627v-3.34H608.64V628.75H605.3v18.43H587v3.34H605.3Zm49,199.7h3.34V850.22H676v-3.34H636v3.34H654.3Zm-48.1-772h3.34V78.12h18.33V74.78h-40.1v3.34H606.2Zm69.77,836H657.64v-18.4H654.3v18.43H636V936h40Zm-48.1-760.7H609.54v-18.3H606.2v18.33H587.77v3.34h40.1ZM605.3,583.15h3.34V564.72H627v-3.34H587v3.34H605.3Zm195.9,0h3.34V564.72H823v-3.34h-40.1v3.34H801.2ZM823,932.58H804.54V914.15H801.2v18.43H782.87V936H823Zm-21.77-64h3.34V850.25H823v-3.34h-40.1v3.34H801.2Zm-48.1-772h3.34V78.12h18.43V74.78h-40.1v3.34H753.1Zm21.77,75.33H756.44V153.55H753.1v18.33H734.77v3.34h40.1ZM752.3,302.45h3.34V284.12H774v-3.34h-40.1v3.34H752.3Zm0,85.7h3.34V369.82H774v-3.34H755.64V348.05H752.3v18.43H733.87v3.34H752.3ZM578.87,171.88H560.54V153.55H557.2v18.33H538.87v3.34h40ZM823,452.18H804.54V433.85H801.2v18.33H782.87v3.34H823ZM801.2,668.85h3.34V650.52H823v-3.34H804.54V628.75H801.2v18.43H782.87v3.34H801.2Zm21.77,64H804.54v-18.4H801.2v18.43H782.87v3.34H823ZM704.1,96.55h3.34V78.12h18.43V74.78h-40.1v3.34H704.1Zm97.1,291.6h3.34V369.82H823v-3.34H804.54V348.05H801.2v18.43H782.87v3.34H801.2Zm-97.9,0h3.34V369.82H725v-3.34H706.64V348.05H703.3v18.43H684.87v3.34H703.3ZM774,932.58H755.64V914.15H752.3v18.43H733.87V936H774ZM703.3,302.45h3.34V284.12H725v-3.34h-40.1v3.34H703.3ZM774,732.88H755.64V714.45H752.3v18.43H733.87v3.34H774ZM752.3,583.15h3.34V564.72H774v-3.34h-40.1v3.34H752.3Zm0,285.4h3.34V850.22H774v-3.34h-40.1v3.34H752.3Zm0-199.7h3.34V650.52H774v-3.34H755.64V628.75H752.3v18.43H733.87v3.34H752.3ZM774,452.18H755.64V433.85H752.3v18.33H733.87v3.34H774Zm-48.1-280.3H707.44V153.55H704.1v18.33H685.77v3.34h40.1ZM105,897.39l-3.34.12.64,18.33h0l.13,3.34h0l.73,18.34,3.34-.14-.73-18.32,18.32-.64-.12-3.34-18.33.64Zm5.5,146.8-3.34.12.64,18.44h0l.13,3.34h0l.73,18.33,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.32.73Zm-1.9-48.91-3.34.14.8,20,.7,20,3.34-.12L109.5,1017l18.33-.64-.12-3.34-18.34.64Zm5.5,146.8-3.34.14.87,21.77,21.67-.87-.14-3.34-18.33.73Zm-7.3-195.79-3.34.12.64,18.44h0l.13,3.34h0l.73,18.34,3.34-.14-.74-18.33,18.44-.73L125.9,964l-18.42.73Zm5.4,143.6-3.34.12.64,18.34h0l.13,3.34h0l.73,18.33,3.34-.14-.73-18.33,18.33-.73-.14-3.34-18.32.73ZM556.3,583.15h3.34V564.72h18.43v-3.34H538v3.34H556.3ZM187.07,171.88H168.64V153.55H165.3v21.67h21.77Zm-2.3,348.76-18.33.64.12,3.34,18.31-.67.73,18.34,3.34-.14-.8-19.94-.7-20-3.34.12ZM168.67,78.12h18.4V74.78H165.3V96.55h3.34ZM90.37,505.78l-3.34.14.8,20,.7,20.09,3.34-.12-.64-18.43,18.33-.64-.12-3.34-18.34.64Zm1.8,48.9-3.34.14.8,20.1.7,20,3.34-.12L93,576.46l18.34-.73-.14-3.34-18.33.74Zm11,293.7-3.34.14.8,20.1.7,20,3.34-.12L104,870.16l18.34-.73-.14-3.34-18.33.73Zm-9-241.4-3.34.14.8,20.1.7,20,3.34-.12L95,628.76l18.34-.73-.14-3.34-18.33.73ZM86.73,497l3.34-.14-.73-18.33,18.43-.73-.14-3.34-21.77.87ZM188.54,621.85l-18.34.73.14,3.34,18.33-.73.73,18.43,3.34-.14-.8-20.1-.7-20-3.34.12Zm-87.1,180.93-3.34.14.8,20.1.7,20,3.34-.12-.64-18.34,18.34-.73-.14-3.34-18.33.73Zm-1.8-48.89L96.3,754l.64,18.33h0l.12,3.34h0L97.79,794l3.34-.14-.73-18.32,18.42-.64-.12-3.34-18.43.64ZM95.94,656l-3.34.14.8,20,.7,20,3.34-.12-.67-18.31L115.1,677l-.12-3.34-18.34.64Zm1.9,48.91L94.5,705l.64,18.44h0l.13,3.34h0L96,745.09l3.34-.14-.74-18.33,18.34-.73-.14-3.34-18.32.73Zm88.79-135.31-18.43.73.14,3.34,18.42-.73.64,18.42,3.34-.12-.64-18.44h0l-.86-21.67-3.34.14Zm269.27-473h3.34V78.12h18.33V74.78h-40.1v3.34H455.9Zm74,75.33H511.54V153.55H508.2v18.33H489.87v3.34h40ZM508.2,96.55h3.34V78.12h18.33V74.78h-40v3.34H508.2Zm-98,0h3.34V78.12H432V74.78h-40.1v3.34H410.2ZM432,171.88H413.54V153.55H410.2v18.33H391.87v3.34H432Zm45.6,0H459.24V153.55H455.9v18.33H437.47v3.34h40.1Zm100.5,760.7H559.64V914.15H556.3v18.43H538V936h40.1ZM556.3,668.85h3.34V650.52h18.43v-3.34H559.64V628.75H556.3v18.43H538v3.34H556.3Zm21.77,64H559.64v-18.4H556.3v18.43H538v3.34h40.1Zm-387.63-62-18.43.64.12,3.34,18.43-.64.64,18.33,3.34-.12-.64-18.33h0L193,652.39l-3.34.14ZM556.3,868.55h3.34V850.22h18.43v-3.34H538v3.34H556.3ZM236,171.88H217.64V153.55H214.3v18.33H196v3.34h40ZM214.3,96.55h3.34V78.12H236V74.78H196v3.34H214.3ZM285,171.88H266.64V153.55H263.3v18.33H244.87v3.34H285ZM192.23,719.75l-18.33.73.14,3.34,18.32-.73.64,18.42,3.34-.12L195.7,723h0l-.13-3.34h0l-.73-18.33-3.34.14Zm169-623.2h3.34V78.12H383V74.78h-40.1v3.34H361.2ZM383,171.88H364.54V153.55H361.2v18.33H342.87v3.34H383ZM315.6,96.55h3.34V78.12h18.43V74.78h-40.1v3.34H315.6Zm21.77,75.33H318.94V153.55H315.6v18.33H297.27v3.34h40.1ZM263.3,96.55h3.34V78.12H285V74.78h-40.1v3.34H263.3Zm685.8,0h3.34V78.12h18.33V74.78h-40.1v3.34H949.1Zm679.8,0h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm-30.53,75.33h-18.43V153.55h-3.34v18.33h-18.33v3.34h40.1Zm52.3,0h-18.43V153.55h-3.34v18.33h-18.33v3.34h40.1ZM1576.6,96.55h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm-12.23,187.57h18.33v18.33H1586V284.12h18.43v-3.34h-40.1Zm49,0h18.33v18.33H1635V284.12h18.43v-3.34h-40.1Zm86.3-112.24h-18.43V153.55h-3.34v18.33h-18.33v3.34h40.1Zm-37.3,283.64H1684V433.85h-3.34v18.33h-18.33Zm0-85.7h18.33v18.33H1684v-40.1h-3.34v18.43h-18.33ZM1677.9,96.55h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm-244.9,0h3.34V78.12h18.43V74.78h-40.1v3.34H1433Zm-15.53,467.77h18.3v18.43h3.34V564.32h18.33V561h-40Zm86.2-392.44h-18.33V153.55H1482v18.33h-18.33v3.34h40ZM801.2,302.45h3.34V284.12H823v-3.34h-40.1v3.34H801.2Zm714.17-18.33h18.4v18.33h3.34V284.12h18.33v-3.34h-40.1Zm-60.6-112.24h-18.43V153.55H1433v18.33h-18.33v3.34h40.1ZM1531,96.55h3.34V78.12h18.33V74.78h-40.1v3.34H1531Zm21.67,75.33h-18.33V153.55H1531v18.33h-18.43v3.34h40.1Zm-67.9,130.57h3.34V284.12h18.33v-3.34h-21.67ZM1482,96.55h3.34V78.12h18.33V74.78h-40v3.34H1482Zm180.4,467.77h18.33v18.43H1684V564.32h18.33V561h-40Zm260.4-467.77h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm70.77,75.33h-18.43V153.55h-3.34v18.33h-18.3v3.34h40.1ZM1873.9,96.55h3.34V78.12h18.33V74.78h-40.1v3.34h18.43Zm70.67,75.33h-18.43V153.55h-3.37v18.33h-18.3v3.34h40.1Zm-49,0h-18.33V153.55h-3.34v18.33h-18.43v3.34h40.1Zm76.2-75.33h3.34V78.12h18.43V74.78h-40.1v3.34h18.33ZM2032,848h18.33v18.43h3.34V844.61H2032Zm-6.7-283.6h18.33v18.4h3.34V561h-21.67ZM2018.6,96.58h3.34V78.12h18.33V74.78h-40v3.34h18.33Zm21.67,75.33h-18.33V153.55h-3.34v18.33h-18.33v3.34h40Zm-280,392.44h18.43v18.4H1782V564.32h18.33V561h-40.1Zm37.3-392.44h-18.33V153.55h-3.34v18.33h-18.33v3.34h40ZM1726.9,96.58h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm-15.63,467.74h18.43v18.43H1733V564.32h18.33V561h-40.1Zm37.4-392.44h-18.43V153.55h-3.34v18.33h-18.33v3.34h40.1Zm97.9,0h-18.33V153.55h-3.34v18.33h-18.43v3.34h40.1Zm-33.9,392.44H1831v18.43h3.34V564.32h18.33V561h-40ZM1775.9,96.55h3.34V78.12h18.33V74.78h-40v3.34h18.33Zm49,0h3.34V78.12h18.33V74.78h-40.1v3.34h18.43ZM1368.47,564.32h18.3v18.43h3.34V564.32h18.33V561h-40ZM1684,302.45V280.78h-21.67v3.34h18.33v18.33ZM1019.77,171.88h-18.43V153.55H998v18.33H979.67v3.34h40.1Zm-.9,760.7h-18.33V914.15H997.2v18.43H978.77V936h40.1Zm1076-760.7h-18.43V153.55h-3.34v18.33h-18.33v3.34h40.1ZM902.54,302.45V280.78H880.87v3.34H899.2v18.33Zm68.23-130.57H952.44V153.55H949.1v18.33H930.67v3.34h40.1Zm-89.9,392.84H899.2v18.43h3.34V564.72H921v-3.34h-40.1ZM997.2,583.15h3.34V564.72h18.33v-3.34h-40.1v3.34H997.2Zm0,85.7h3.34V650.52h18.33v-3.34h-18.33V628.75H997.2v18.43H978.77v3.34H997.2Zm21.67,64h-18.33v-18.4H997.2v18.43H978.77v3.34h40.1ZM997.2,868.52h3.34V850.19h18.33v-3.34h-40.1v3.34H997.2ZM931,564.72H949.3v18.43h3.34V564.72H971v-3.34H931ZM847.77,96.55h3.34V78.12h18.36V74.78h-40.1v3.34h18.4Zm33.1,273.27H899.2v18.33h3.34v-40.1H899.2v18.43H880.87ZM802.1,96.55h3.34V78.12h18.43V74.78h-40.1v3.34H802.1Zm21.77,75.33H805.44V153.55H802.1v18.33H783.77v3.34h40.1Zm45.6,0H851.14V153.55h-3.37v18.33h-18.4v3.34h40.1ZM1384,96.55h3.34V78.12h18.43V74.78h-40.1v3.34H1384Zm-503.13,359h21.67v-21.7H899.2v18.33H880.87Zm37.6-283.64H900V153.55H896.7v18.33H878.37v3.34h40.1Zm-86.6,112.21H850.2v18.33h3.34V284.12H872v-3.34h-40.1ZM896.7,96.55H900V78.12h18.43V74.78h-40.1v3.34H896.7Zm362.37,75.33h-18.3V153.55h-3.34v18.33H1219v3.34h40.1Zm29.53-75.33h3.34V78.12h18.33V74.78h-40.1v3.34h18.43ZM1270.47,848h18.3v18.43h3.34V848h18.43v-3.34h-40.1ZM1237.4,96.55h3.37V78.12h18.33V74.78H1219v3.34h18.43Zm2.4,769.8h3.34V848h18.43v-3.34h-21.8Zm70.47-694.47h-18.33V153.55h-3.34v18.33h-18.43v3.34h40.1Zm27.5,410.87h3.34V564.32h18.43V561h-21.77Zm68-410.87h-18.43V153.55H1384v18.33h-18.33v3.34h40.1Zm-50.7,0h-18.3V153.55h-3.34v18.33H1315v3.34h40.1ZM1333.4,96.55h3.37V78.12h18.33V74.78H1315v3.34h18.43Zm-170,75.33h-18.33V153.55h-3.34v18.33h-18.46v3.34h40.1ZM1043.7,96.55H1047V78.12h18.33V74.78h-40.1v3.34h18.43Zm70.67,75.33H1096V153.55h-3.34v18.33h-18.43v3.34h40.1Zm-88.3,392.84h18.43v18.43h3.34V564.72h18.33v-3.34h-40.1Zm39.3-392.84H1047V153.55h-3.34v18.33h-18.43v3.34h40.1Zm27.33-75.33H1096V78.12h18.33V74.78h-40.1v3.34h18.43Zm97.9,0h3.34V78.12h18.43V74.78h-40.1v3.34h18.33Zm-48.9,0H1145V78.12h18.33V74.78h-40.1v3.34h18.43Zm70.67,75.33h-18.43V153.55h-3.34v18.33h-18.33v3.34h40.1ZM998,96.55h3.34V78.12h18.43V74.78h-40.1v3.34H998Z"
            />
        </g>
    </svg>
</div>

<app-tooltip-garage-user
    *ngIf="isGarageUser"
    [tooltipData]="tooltipParkingSlotInfo"
    [floorNumber]="1">
</app-tooltip-garage-user>

<app-tooltip-garage-user-reservation
    *ngIf="isGarageUser"
    [tooltipData]="tooltip"
    [reservationStatus]="reservationStatus"
    [floorNumber]="1"
    (onTimeEnd)="updateCurrentReservationWithDelay()"
    (onExtendReservation)="extendReservation()">
</app-tooltip-garage-user-reservation>

<app-tooltip-admin
    *ngIf="isAdminOrReceptionist"
    [floorNumber]="1"
    [swapTooltip]="swapTooltip"
    [swapPlaceMode]="swapPlaceMode"
    (onSwap)="swapParkingSlot()"
    [tooltipData]="tooltip">
</app-tooltip-admin>

<div *ngIf="!isProduction && isGarageUser" class="emulate-gate">
    <div *ngIf="reservationStatus && reservationStatus.user">
        <a target="_blank" (click)="inGarage()">
            <img src="/assets/images/temp_icon_IN.svg" alt="in"/>
        </a>
        <a target="_blank" (click)="leftGarage()">
            <img src="/assets/images/temp_icon_OUT.svg" alt="out"/>
        </a>
    </div>
</div>
